import React from 'react';
import { useSystemSettings } from '@/modules/admin/settings/hooks/useSystemSettings';

export function ScriptInjector() {
  const { advanced } = useSystemSettings();

  React.useEffect(() => {
    if (!advanced) return;

    // 1. Inject Custom CSS
    const styleId = 'system-custom-css';
    let styleTag = document.getElementById(styleId) as HTMLStyleElement;
    
    if (advanced.customCss) {
      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = styleId;
        document.head.appendChild(styleTag);
      }
      styleTag.innerHTML = advanced.customCss;
    } else if (styleTag) {
      styleTag.remove();
    }

    // 2. Inject Header Scripts
    const headerScriptsId = 'system-header-scripts';
    let headerContainer = document.getElementById(headerScriptsId);
    
    if (advanced.customHeaderScripts) {
      if (headerContainer) headerContainer.remove(); // Re-inject on change
      
      headerContainer = document.createElement('div');
      headerContainer.id = headerScriptsId;
      headerContainer.style.display = 'none';
      
      // Parse scripts (hacky but works for simple GA tags)
      const range = document.createRange();
      const fragment = range.createContextualFragment(advanced.customHeaderScripts);
      headerContainer.appendChild(fragment);
      document.head.appendChild(headerContainer);
    }

    // 3. Inject Body Scripts
    const bodyScriptsId = 'system-body-scripts';
    let bodyContainer = document.getElementById(bodyScriptsId);
    
    if (advanced.customBodyScripts) {
      if (bodyContainer) bodyContainer.remove();
      
      bodyContainer = document.createElement('div');
      bodyContainer.id = bodyScriptsId;
      bodyContainer.style.display = 'none';
      
      const range = document.createRange();
      const fragment = range.createContextualFragment(advanced.customBodyScripts);
      bodyContainer.appendChild(fragment);
      document.body.appendChild(bodyContainer);
    }

    // 4. Debug Mode Logging
    if (advanced.debugMode) {
      console.log('🚀 [System] Debug Mode is ON');
      console.log('🛠️ [System] Advanced Config:', advanced);
    }

  }, [advanced]);

  return null;
}
